import styled from '@emotion/styled';

export const TraderChatWrapper = styled('div', { label: 'TraderChatWrapper' })`
    display: flex;
    flex-flow: column nowrap;
    height: 100%;
`;
